function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Phone_x2F_sound_off"
}, /*#__PURE__*/React.createElement("title", null, "VF_Rityta 1_rgb"), /*#__PURE__*/React.createElement("circle", {
  cx: "141.7",
  cy: "223.182",
  r: "17.7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.5 42.482H163v14.2h-42.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78 59.625V28.282h127.5v117.593l28.4 19.212V28.282c-.1-15.6-12.7-28.281-28.4-28.281H78C62.3 0 49.6 12.682 49.6 28.282v12.131L78 59.625zM205.5 216.741v38.341H78v-124.59L49.6 111.28v143.802c0 15.7 12.7 28.382 28.4 28.382h127.5c15.7 0 28.3-12.682 28.4-28.382v-19.129l-28.4-19.212zM21.26 42.502v28.346l240.945 162.993v-28.347z"
}))));